import {
  useState, useEffect,
} from 'react';

export const viewSizes = {
  extraSmall: 'extraSmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export type ViewSizes = (typeof viewSizes)[keyof typeof viewSizes];

const {
  extraSmall, small, medium, large,
} = viewSizes;

function getViewSize(windowWidth: number) {
  if (windowWidth <= 540) {
    return extraSmall;
  }
  if (windowWidth <= 767) {
    return small;
  }
  if (windowWidth <= 1199) {
    return medium;
  }
  return large;
}

export function useViewSize() {
  const [viewSize, setViewSize] = useState(
    getViewSize(window.innerWidth),
  );

  useEffect(() => {
    const handleResize = (): void => {
      setViewSize(getViewSize(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return viewSize;
}
